import { Grid } from '@mui/material';
import { useOperatorsDriversFilesQuery, useOperatorsDriversQuery } from 'api/queries/operators';
import FormCard from 'components/FormCard';
import DriverDocumentsForm from 'components/forms/DriverFormFactory/DriverDocumentsForm';
import { FileTypeEnum } from 'remote/global';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

function DriverDocumentsView() {
  const { id } = useParams();
  const { data: driver, isSuccess: isDriverSuccess } = useOperatorsDriversQuery(id!);
  const { data: driverFiles, isSuccess: isFilesSuccess } = useOperatorsDriversFilesQuery(id!);
  const { t } = useTranslation();

  if (!isDriverSuccess || !isFilesSuccess) return null;

  const driverCertifications = driverFiles.filter(
    ({ fileType }) => fileType === FileTypeEnum.DRIVER_PROFESSIONAL_CERT
  );
  const driverLicenses = driverFiles.filter(
    ({ fileType }) => fileType === FileTypeEnum.DRIVING_LICENSE
  );

  return (
    <Grid container gap={4}>
      <Grid item container width='421px' textAlign='left'>
        <FormCard title={t('DriversView.DetailView.driverDocuments.title')}>
          <DriverDocumentsForm
            driverId={String(driver.id)}
            defaultValues={{ driverCertifications, driverLicenses }}
          />
        </FormCard>
      </Grid>
    </Grid>
  );
}

export default DriverDocumentsView;
